export default __webpack_public_path__ + "static/media/MVC-Tech-Blog.4aa607a8.png";